import { createAction, emptyProps, props } from '@ngrx/store';
import { ILogin, IToken } from 'src/app/shared/interfaces/utils.interface';
import { IAuth } from './auth.states';
import { AdminRole, MerchantRole } from 'src/app/shared/enums/roles';
import type { IUserProfile } from '../user/user.states';

export const login = createAction('[Auth] Login', props<{ login: ILogin }>());

export interface ILineLoginPayload {
  idToken: string;
}

export const lineLogin = createAction(
  '[Auth] LINE Login',
  props<{ payload: ILineLoginPayload }>(),
);

export const lineLoginFailed = createAction(
  '[Auth] LINE Login Failed',
  props<{ error: string }>(),
);

export const loginSuccess = createAction(
  '[Auth] Login Success',
  props<{ currentUser: IAuth }>(),
);

export const authenticatedProfileReady = createAction(
  '[Auth] Authenticated Profile Ready',
  props<{ currentUser: IAuth; profile: IUserProfile | null }>(),
);

export const authenticatedProfileFailed = createAction(
  '[Auth] Authenticated Profile Failed',
  props<{ error: string }>(),
);

export const initAuth = createAction('[Auth] Init Auth', emptyProps);
export const loadAuth = createAction(
  '[Auth] Load Auth',
  props<{ currentUser: IAuth | null }>(),
);

export const setIsFirstTime = createAction(
  '[Auth] Set IsFirstTime',
  props<{ isFirstTime: boolean }>(),
);

export const storedAuth = createAction('[Auth] Stored Auth', emptyProps);

export const loginFailed = createAction(
  '[Auth] Login Failed',
  props<{ error: string | null }>(),
);

// export const logoutRequest = createAction(
//   '[Auth User] Notify server to logout',
//   emptyProps
// );
export const logoutSuccess = createAction(
  '[Auth User] Notify server to logout',
  emptyProps,
);

export const logoutFailure = createAction(
  '[Auth User] Logout FAILURE',
  props<{ error: string | null }>(),
);
export const updateToken = createAction(
  '[Auth User] Update Token',
  props<{ token: IToken }>(),
);
export const updateRoles = createAction(
  '[Auth User] Update Roles',
  props<{ roles: AdminRole | MerchantRole }>(),
);
